<button
  pButton
  pRipple
  [type]="type"
  [icon]="icon"
  [label]="label"
  [disabled]="disabled"
  [loading]="loading"
  [ngClass]="buttonClasses"
  pTooltip="{{ tooltip }}"
  tooltipPosition="{{ tooltipPosition }}"
  (click)="onClick.emit($event)"
></button>
